module.exports = __webpack_public_path__ + "media/Gif3.f87da196.mp4";